"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DangerousRoadIcon = DangerousRoadIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function DangerousRoadIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5645_13897)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#FFEBF5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.985 23.6465C20.7378 23.6468 21.3475 24.258 21.3477 25.0108C21.3474 25.7636 20.7377 26.3733 19.985 26.3736C19.232 26.3735 18.621 25.7637 18.6206 25.0108C18.6208 24.2579 19.232 23.6465 19.985 23.6465Z",
    fill: "#DA3A87"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.8476 14.1008C20.5252 14.1008 21.0746 14.6501 21.0746 15.3278V21.0568L21.0682 21.1814C21.0053 21.8 20.4828 22.2837 19.8476 22.2837C19.2124 22.2837 18.6899 21.8 18.627 21.1814L18.6206 21.0568V15.3278C18.6206 14.6502 19.17 14.1009 19.8476 14.1008Z",
    fill: "#DA3A87"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M16.662 8.60346C18.138 6.02131 21.8625 6.02105 23.3384 8.60346L32.8217 25.201C34.2855 27.7637 32.4343 30.9523 29.4827 30.9523H10.516C7.56478 30.9519 5.71491 27.7636 7.17861 25.201L16.662 8.60346ZM21.2072 9.82083C20.6732 8.88723 19.3254 8.88702 18.7916 9.82083L9.30821 26.4183C8.77969 27.345 9.44908 28.498 10.516 28.4984H29.4827C30.5502 28.4984 31.2198 27.3453 30.6905 26.4183L21.2072 9.82083Z",
    fill: "#DA3A87",
    fillRule: "evenodd"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5645_13897"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    height: "40",
    width: "40"
  }))));
}